import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Routes from "./Routes";
import { siteName } from "./database/apiv2SiteAccessor";
import {GrantRequests} from './Grants/GrantRequests'
import AppTour from "./AppTour/AppTour";

import "./App.css";
//import Amplify from 'aws-amplify';
//import awsconfig from './aws-exports';

class App extends Component {
  constructor(props) {
    super(props);

    //Amplify.configure(awsconfig);
    const savedId = localStorage.getItem("sessionId");
    const authenticated = savedId ? savedId.length > 8 : false; //valid token?

    this.state = {
      isAuthenticated: authenticated,
      isAuthenticating: true,
      userLogin: localStorage.getItem("name"),
      authToken: savedId,
      loginTime: localStorage.getItem("loginTime"),
      activeSite: null,
      currentSite: "",
      batteryFormat: 0,
      radioFormat: 0,
      breadCrumb: undefined,
      //  Tour states 
      dropMenu: false,
      reqPending: 0,
    };
    this.tour=true
    this.siteLocation='login'
    this.siteListCache=null
    this.siteMapCache=new Map()
    this.mapPosition=null
    this.mapZoom=null
    this.grantInterval = 60 * 60000;    //hourly
    this.grantTimer = undefined
    this.checkRequest = this.checkRequest.bind(this)
    this.loginExpired();
    this.siteCache = {
      getter:this.sitesCached,
      setter:this.siteMap,
    }
  }

  authenticatedUser = (loginId, token) => {
    const loginAt = Date.now();
    const bf = localStorage.getItem("battFormat") ?? 0;
    this.setState({
      userLogin: loginId,
      authToken: token,
      isAuthenticated: true,
      loginTime: loginAt,
      batteryFormat: bf,
    });
    localStorage.setItem("sessionId", token);
    localStorage.setItem("name", loginId);
    localStorage.setItem("loginTime", loginAt);
    this.checkRequest()
    this.grantTimer = setInterval (this.checkRequest, this.grantInterval)
  };

  userHasAuthenticated = (authenticated) => {
    this.setState({ isAuthenticated: authenticated });
    if (authenticated === false) {
      localStorage.setItem("sessionId", -1);
      clearInterval(this.grantTimer)
    }
  };

  loginExpired = () => {
    let retcode = false;
    if (this.state.isAuthenticated) {
      const elapsedSeconds = Math.abs(
        (Date.now() - this.state.loginTime) / 1000
      );
      retcode = elapsedSeconds > 10 * 60 *60; // 10 hours
      if (retcode) {
        this.userHasAuthenticated(false);
        clearInterval(this.grantTimer)
      }
      else {
        this.grantTimer ??= setInterval (this.checkRequest, this.grantInterval)
      }
    }
    return retcode;
  };

  currentSiteInfo = (name) => {
    this.setState({ currentSite: name });
    return name;
  };

  setActiveSite = (site) => {
    if (site === null) return this.clearActiveSite();

    const name = siteName(site);
    this.setState({ currentSite: name, activeSite: site });
    return name;
  };
  getActiveSite = () => {
    return this.state.activeSite;
  };
  clearActiveSite = () => {
    this.setState({ currentSite: "", activeSite: null });
    return "";
  };
  // pass zero to get the current, or non-zero to toggle
  radioFormat = (getOrSet) => {
    if (getOrSet) {
      const newval = this.state.radioFormat ? 0 : 1;
      this.setState({ radioFormat: newval });
      return newval;
    }
    return this.state.radioFormat;
  };
  batteryFormat = (format) => {
    if (typeof format !== "undefined") {
      this.setState({ batteryFormat: format });
      localStorage.setItem("battFormat", format);
      return format;
    }
    return this.state.batteryFormat;
  };
  // pass something to set, or nothing to read
  /*siteList = (setList = null, rerender = false) => {
    if (setList) {
      this.siteListCache = setList
    }
    if (rerender)
      this.setState({batteryFormat: this.state.batteryFormat})
    return this.siteListCache;
  };*/
  sitesCached =() => {
    return this.siteMapCache.size > 0 ? true : null
  }
  siteMap = (setMap = undefined) => {
    if (setMap) {
      this.siteMapCache = setMap
      this.setState({batteryFormat: this.state.batteryFormat})
    }
    return this.siteMapCache;
  }
  clearCrumb = () => {
    this.setState({breadCrumb: undefined})
  }
  breadCrumb = (view) => {
    if (view) {
      this.setState({ breadCrumb: view });
      return view;
    }
    return this.state.breadCrumb;
  };
  updateSiteListCache = (key, updObj) => {
    let active = this.getActiveSite();
    if (!active) return
    if (active[key] && 'object' === typeof updObj) {
      Object.assign(active[key], updObj)
    }
    else{
      active[key] = updObj
    }
  };
  viewObj(loc, zoom) {
    return { loc: loc, zoom: zoom };
  }
  cacheMapView = (viewLocation, zoom) => {
    if (viewLocation) {
      this.mapPosition = viewLocation
      this.mapZoom = zoom
    }
    return viewLocation
      ? this.viewObj(viewLocation, zoom)
      : this.viewObj(this.mapPosition, this.mapZoom);
  };

  checkRequest() {
    if (this.loginExpired()) {
      this.props.history.push('/login')
      return
    }
    GrantRequests (this.state)
      .then(resp => {
        const count = resp?.req?.length ?? 0
        if (count !== this.state.reqPending)
          this.setState({reqPending: count})
      })
    }

  /* -------------- Initial tour launch on first load on sitelist -------------
  componentDidMount() {
    this.launchTourStatus(true);
  } */
 // Tour helper functions
  /* ------------------------- update state functions ------------------------- */
  launchTourStatus = (status) => {
    this.tour = status
  };

  updateDropmenuState = (newValue) => {
    if (newValue !== this.state.dropMenu)
      this.setState({ dropMenu: newValue });
  };

  updateSiteLocation = (location) => {
    this.siteLocation = location
  };
  // End tour helper functions
  
  render() {
    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      loginExpired: this.loginExpired,
      userLogin: this.state.userLogin,
      authToken: this.state.authToken,
      authenticatedUser: this.authenticatedUser,
      userHasAuthenticated: this.userHasAuthenticated,
      currentSiteInfo: this.currentSiteInfo,
      currentSite: this.state.currentSite,
      setActiveSite: this.setActiveSite,
      getActiveSite: this.getActiveSite,
      radioFormat: this.radioFormat,
      radioStyle: this.state.radioFormat,
      batteryFormat: this.batteryFormat,
      // siteList: this.siteList,
      siteMap: this.siteMap,
      siteCacheSize: this.siteMap()?.size ?? 0,
      breadCrumb: this.breadCrumb,
      clearCrumb: this.clearCrumb,
      //cachePermission: this.cachePermission,
      updateSiteListCache: this.updateSiteListCache,
      mapView: this.cacheMapView,
      grantReq: this.state.reqPending,
      siteCache: this.siteCache,
      /* ---------------------------- Tour state props ---------------------------- */
      dropMenu: this.state.dropMenu,
      updateDropmenuState: this.updateDropmenuState,
      location: this.props.location,
      tour: this.tour,
      launchTourStatus: this.launchTourStatus,
      /*You can use the variable and function below anywhere in the app 
      to get the location information or update that information */
      updateSiteLocation: this.updateSiteLocation,
      siteLocation: this.siteLocation,
    };
    return (
      <div>
        <AppTour {...childProps} />
        <Routes childProps={childProps} />
      </div>
    );
  }
}
export default withRouter(App);
